<template>
  <div>
    <div class="more_box flex_center flex_center_align btn_open">
      <svg-icon icon-class="select" @click="openDialog" />
      <div></div>
    </div>
    <el-dialog
      class="mode"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="layout-dialog"
      title="商品明细管理"
      top="5vh"
      width="900px"
      :show-close="false"
      :visible.sync="dialogVisible"
      append-to-body
      @close="close"
    >
      <vab-query-form-mode
        class="dpform noborder"
        :model="queryForm"
        :rules="rules"
        :enable-query-save="false"
        size="mini"
        label-position="left"
        label-width="140px"
        @search="onSearch"
      >
        <el-row :gutter="30" class="flex_center_align">
          <el-col :span="6">
            <vab-input
              label="商品"
              label-width="100px"
              prop="itmcd"
              maxlength="4"
            />
          </el-col>
          <el-col :span="6" style="padding-left: 0px">
            <el-input label-width="100px" prop="itmcd" maxlength="4" disabled />
          </el-col>
          <el-col :span="12">
            <div class="text_color">管理部門</div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="flex_center_align">
          <el-col :span="12">
            <vab-input
              label="商品明细"
              label-width="100px"
              prop="itmcd"
              maxlength="4"
            />
          </el-col>
          <el-col :span="12">
            <vab-radio-group
              label="支給品"
              label-width="100px"
              prop="supplyGoodFlg"
              :code-enum="$divisions.existFlagEnum"
              filter="existFlag"
            />
          </el-col>
        </el-row>
      </vab-query-form-mode>
      <el-row class="m20">
        <el-col :span="24">
          <vab-table
            ref="table"
            api-url="/api/mitmbasp/query"
            :columns="columns"
            :custom-config="false"
            height="350"
            :init-params="{
              ...queryForm,
              sidx: 'itmcd',
              sort: 'asc',
            }"
            :query-params="{
              ...queryForm,
              sidx: 'itmcd',
              sort: 'asc',
            }"
            primary-key="itmcd"
            primary-key-sort="asc"
            :enable-init="false"
          >
            <template #radioBox="{ row }">
              <vab-radio-group
                label="支給品"
                label-width="100px"
                prop="supplyGoodFlg"
                :code-enum="row.sectionCdList"
                filter="existFlag"
              />
            </template>
          </vab-table>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer flex_end">
        <div class="flex_start flex_center_align">
          <div class="cancel" @click="close">キャンセル</div>
          <el-button type="primary">確定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'Details',
    data() {
      return {
        dialogVisible: false,
        rules: {},
        queryForm: {
          sectionCdList: null,
          itemCdList: null,
          itemDetailCdList: null,
          progressDepCdList: null,
          chargePersonCdList: null,
          supplierCdList: null,
        },
        columns: [
          {
            label: '商品CD',
            'min-width': 80,
            prop: 'itmcd',
          },
          {
            label: '商品名',
            'min-width': 120,
            prop: 'itmnm',
          },
          {
            label: '商品明細CD',
            'min-width': 80,
            prop: 'itmnmk',
          },
          {
            label: '商品明細',
            'min-width': 120,
            prop: 'itmnmk',
          },
          {
            label: '商品明細',
            'min-width': 175,
            slotScope: 'radioBox',
          },
        ],
      }
    },
    methods: {
      onSearch() {},
      openDialog() {
        this.dialogVisible = true
      },
      close() {
        this.dialogVisible = false
        // this.$emit('update:visibleWork', false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .more_box {
    width: 100% !important;
  }

  .text_color {
    font-weight: 400;
    color: #000000;
  }
</style>
